import { validatedApi } from '@/lib/api';
import type { AmenityConfig } from '@lov/shared';

export const configApi = {
  async getAmenities(params?: { venueType?: string }): Promise<AmenityConfig[]> {
    const queryParams = new URLSearchParams();
    if (params?.venueType) {
      queryParams.set('venueType', params.venueType);
    }

    return validatedApi.get<AmenityConfig[]>(
      `/config/amenities${queryParams.toString() ? `?${queryParams.toString()}` : ''}`
    );
  },
};
